var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSweets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.103882,
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2668_62624)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1524 26.6039C10.7611 26.6039 8 24.0963 8 21.014C8 20.7849 8.18656 20.5975 8.41458 20.5975H19.4217C20.0228 20.2559 20.4415 20.0143 20.6322 19.8977C25.1138 17.1402 27.8045 17.0361 29.4089 16.9736H29.5498C29.5498 16.9736 29.5954 16.9611 29.6286 16.9611H30.7687C31.4486 16.9611 32 17.5151 32 18.1982C32 18.8814 31.4486 19.4353 30.7687 19.4353H29.811C29.811 19.4353 29.7861 19.4353 29.7737 19.4353C23.7789 19.6769 19.2185 24.2088 19.1729 24.2546C19.1688 24.2588 19.1605 24.2671 19.1563 24.2713C17.9997 25.7375 16.1382 26.608 14.1524 26.608V26.6039Z",
    fill: "#585C60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0889 19.527V16.0989L13.9537 17.2944V19.527H18.4767V15.4741C18.4767 15.4741 18.4767 15.47 18.4767 15.4658C18.4767 15.4616 18.4767 15.4533 18.4767 15.4491C18.4767 15.4075 18.4643 15.3658 18.4477 15.3242C18.4477 15.3158 18.4394 15.3075 18.4353 15.295C18.4145 15.2534 18.3897 15.2159 18.3565 15.1825C18.3482 15.1742 18.3441 15.17 18.3358 15.1659C18.3192 15.1534 18.3068 15.1367 18.2902 15.1284C18.2694 15.1159 18.2446 15.1034 18.2238 15.0951C18.2238 15.0951 18.2155 15.0909 18.2114 15.0867L14.5382 13.6372H14.5258C14.5258 13.6372 14.4926 13.6289 14.476 13.6247C14.4429 13.6164 14.4097 13.608 14.3724 13.608C14.3392 13.608 14.3061 13.6164 14.2687 13.6247C14.2522 13.6289 14.2356 13.6247 14.219 13.633H14.2066C14.2066 13.633 14.2066 13.6372 14.2066 13.6414L10.5251 15.0867C10.5251 15.0867 10.5168 15.0909 10.5168 15.0951C10.4919 15.1034 10.4712 15.1159 10.4463 15.1284C10.4297 15.1409 10.4173 15.1534 10.4007 15.1659C10.3924 15.17 10.3841 15.1784 10.38 15.1825C10.3468 15.2159 10.322 15.2534 10.3012 15.295C10.2971 15.3033 10.2929 15.3117 10.2888 15.3242C10.2722 15.3658 10.2639 15.4075 10.2598 15.4491C10.2598 15.4533 10.2598 15.4616 10.2598 15.4658C10.2598 15.4658 10.2598 15.47 10.2598 15.4741V19.527H11.0889ZM14.3682 14.4661L16.9552 15.4866L14.3682 16.5654L11.7813 15.4866L14.3682 14.4661Z",
    fill: "#585C60"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2668_62624"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 13,
    fill: "white",
    transform: "translate(8 13.6039)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSweets);
export default __webpack_public_path__ + "static/media/sweets.a49b360b6a1fadcc2fd5d7eef84601af.svg";
export { ForwardRef as ReactComponent };